import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { makeStyles } from '@mui/styles';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import CallIcon from '@mui/icons-material/Call';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import EmailIcon from '@mui/icons-material/Email';
import PlaylistAddCheckOutlinedIcon from '@mui/icons-material/PlaylistAddCheckOutlined';
import PlaylistAddCheckRoundedIcon from '@mui/icons-material/PlaylistAddCheckRounded';
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import EventNoteIcon from '@mui/icons-material/EventNote';

const useStyles = makeStyles({
  singleBtn: {
    border: 'unset',
    '&.Mui-disabled': {
      border: 'unset',
    },
    '&.Mui-selected, &.Mui-selected:hover': {
      backgroundColor: 'unset',
    },
  },
});

const HistoryFilters = function HistoryFilters({
  selectedFilter = 'CALL',
  handleSelectFilter,
}) {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <ToggleButtonGroup
      className={classes.toggleBtns}
      value={selectedFilter}
      onChange={handleSelectFilter}
      aria-label={intl.messages.HISTORY_FILTERS}
      exclusive
    >
      <ToggleButton
        value="ALL"
        color="primary"
        className={classes.singleBtn}
        title={intl.messages.SHOW_ALL}
      >
        {selectedFilter === 'ALL' ? (
          <PlaylistAddCheckRoundedIcon />
        ) : (
          <PlaylistAddCheckOutlinedIcon />
        )}
      </ToggleButton>
      <ToggleButton
        value="CALL"
        color="success"
        className={classes.singleBtn}
        title={intl.messages.SHOW_CALLS}
      >
        {selectedFilter === 'CALL' ? <CallIcon /> : <CallOutlinedIcon />}
      </ToggleButton>
      <ToggleButton
        value="APPOINTMENT"
        color="warning"
        className={classes.singleBtn}
        title={intl.messages.SHOW_APPOINTMENTS}
      >
        {selectedFilter === 'APPOINTMENT' ? (
          <EventNoteIcon />
        ) : (
          <EventNoteOutlinedIcon />
        )}
      </ToggleButton>
      <ToggleButton
        value="EMAIL"
        color="error"
        className={classes.singleBtn}
        title={intl.messages.SHOW_EMAILS}
      >
        {selectedFilter === 'EMAIL' ? <EmailIcon /> : <EmailOutlinedIcon />}
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

HistoryFilters.propTypes = {
  selectedFilter: PropTypes.string,
  handleSelectFilter: PropTypes.func.isRequired,
};

export default HistoryFilters;
